module.exports = __webpack_public_path__ + "img/sun-7522095_1280.23ecf001.jpg";